import { render, staticRenderFns } from "./AppDetailedSubHeader.vue?vue&type=template&id=a4fde226&scoped=true&"
import script from "./AppDetailedSubHeader.vue?vue&type=script&lang=js&"
export * from "./AppDetailedSubHeader.vue?vue&type=script&lang=js&"
import style0 from "./AppDetailedSubHeader.vue?vue&type=style&index=0&id=a4fde226&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a4fde226",
  null
  
)

export default component.exports